import {DurationType} from '@domain/stoppages'
import {textFieldFilterSx} from '@hconnect/common/styles'
import {mergeSxs} from '@hconnect/uikit'
import {Checkbox, MenuItem, TextField} from '@mui/material'
import {RemoveFilterButton} from '@widgets/common-filters'
import {last} from 'lodash'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type DurationTypeItem = {
  type: DurationType
  description: string
}

type Props = {
  value?: DurationType[]
  onChange: (durationType?: DurationType[]) => void
  clearFilter: () => void
}

const keyName = 'duration'

export const StoppageDurationFilter: React.FC<Props> = ({value, onChange, clearFilter}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const durationTypes: DurationTypeItem[] = [
    {
      type: DurationType.upTo1h,
      description: t('filters.duration.upTo1h')
    },
    {
      type: DurationType.between1hAnd24h,
      description: t('filters.duration.between1hAnd24h')
    },
    {
      type: DurationType.moreThan24h,
      description: t('filters.duration.moreThan24h')
    }
  ]

  return (
    <TextField
      variant="filled"
      sx={mergeSxs(textFieldFilterSx, {width: 210})}
      data-test-id="events-filter-bar-stoppage-duration"
      label={t('filters.addFilter.stoppageDuration')}
      required={false}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        const val = event.target.value as unknown as DurationType[] | undefined
        if (!val) onChange(undefined)
        else {
          if (val.length === 2 && !val.includes(DurationType.between1hAnd24h)) {
            const next = val.filter((duration) => duration === last(val))
            onChange(next)
          } else {
            onChange(val)
          }
        }
      }}
      value={value ?? []}
      SelectProps={{
        multiple: true,
        renderValue: (args: unknown) =>
          (args as DurationType[])
            .map((arg: DurationType) => t(`filters.${keyName}.${arg}`))
            .join(', ')
      }}
      select
    >
      {durationTypes.map((option) => (
        <MenuItem data-test-id={`option-${option.type}`} key={option.type} value={option.type}>
          <Checkbox
            checked={!!value?.find((duration) => duration === option.type)}
            data-test-id={`failure-checkbox-${option.type}`}
          />
          {option.description}
        </MenuItem>
      ))}
      <RemoveFilterButton keyName={keyName} removeFilter={clearFilter} />
    </TextField>
  )
}
